import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WBrightcoveCCD: IClientComponentDefinition = {
  name: 'WBrightcove',
  load: () => import(/* webpackChunkName: 'WBrightcove' */ '.'),
}
